
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/concierge/shows/[slug]",
      function () {
        return require("private-next-pages/concierge/shows/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/concierge/shows/[slug]"])
      });
    }
  